// replace format @@placeholder@@ with link
export const replacePlaceholdersWithLinks = (text, dynamicLinks) => {
    return dynamicLinks.reduce((acc, { placeholder, linkDestination, linkDisplayValue }) => {
        return acc.replaceAll(`@@${placeholder}@@`, `<a href="${linkDestination}" target="_blank" rel="noopener">${linkDisplayValue}</a>`);
    }, text);
};
export const replaceOneTrustPlaceholdersWithLinks = (text, links) => {
    return replacePlaceholdersWithLinks(text, links || []);
};
//# sourceMappingURL=linkReplacer.js.map